import React, { useState, useEffect, useContext } from 'react';
import './EditEVGroup.scss';
import configuration from '../../config';
import getResponse from '../../utilities/FetchHelper';

import { useCampusFeatureFlags } from '../../context/CampusContextProvider';

import Modal from '../Modal';
import Checkbox from '../Checkbox';

const EditEvGroup = ({
  clearModal,
  modalImage,
  selectedGXId,
  selectedGroup,
  updateDeviceData,
  setProcessing,
  errorMessage,
  setErrorMessage,
  errorMessageRef,
  showMobile,
  allEVs,
}) => {
  const { hasBattery } = useCampusFeatureFlags();

  const [groupForm, setGroupForm] = useState({});
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isNewGroup, setIsNewGroup] = useState(false);
  const [capacityArray, setCapacityArray] = useState([]);

  useEffect(() => {
    let initialKeys = [];

    calculateCapacity();

    if (selectedGroup && selectedGroup.evChargers) {
      selectedGroup.evChargers?.map((charger) => {
        setSelectedKeys((prevState) => [...prevState, charger.entityKey]);
        initialKeys.push(charger.entityKey);
      });
    }

    setGroupForm({
      evChargerGroupName: selectedGroup.evChargerGroupName,
      evChargerGroupId: selectedGroup.evChargerGroupId,
      evChargerEntityKeys: initialKeys,
      powerDecisionLimits: selectedGroup.powerDecisionLimits,
    });

    if (selectedGroup.evChargerGroupId === '') {
      setIsNewGroup(true);
    }
  }, []);

  useEffect(() => {
    setGroupForm((prevState) => ({
      ...prevState,
      evChargerEntityKeys: selectedKeys,
    }));

    calculateCapacity();
  }, [selectedKeys]);

  function calculateCapacity() {
    let valuesArray = [];
    let newCapacityArray = [];
    let maxTotal = 0;

    Object.values(selectedGroup.powerDecisionLimits).map((value) => {
      valuesArray.push(value / 100);
    });

    allEVs?.map((charger) => {
      if (selectedKeys.includes(charger.entityKey)) {
        maxTotal = maxTotal + charger.maxCapacityPowerkW;
      }
    });

    for (let i = 0; i < valuesArray.length; i++) {
      newCapacityArray.push((valuesArray[i] * maxTotal).toFixed(2));
    }

    setCapacityArray(newCapacityArray);
  }

  const handleDeviceClick = (e) => {
    const { id, checked } = e.target;

    if (checked) {
      setSelectedKeys((prevState) => [...prevState, id]);
    } else {
      setSelectedKeys(selectedKeys.filter((item) => item !== id));
    }
  };

  const handleSelectAll = (e) => {
    const { checked } = e.target;

    if (checked) {
      setSelectedKeys(allEVs.map((charger) => charger.entityKey));
    } else {
      setSelectedKeys([]);
    }
  };

  const groupList = allEVs?.map((charger) => {
    return (
      <div className="devices" key={charger.entityKey}>
        <Checkbox
          id={charger.entityKey}
          name={charger.shortDescription}
          type="checkbox"
          onChange={handleDeviceClick}
          checked={selectedKeys.includes(`${charger.entityKey}`)}
        />
        {charger.shortDescription}
      </div>
    );
  });

  const handleInputUpdate = (e) => {
    const { name, value } = e.target;

    Object.entries(groupForm.powerDecisionLimits).map(([key, currentValue]) => {
      if (key === name) {
        groupForm.powerDecisionLimits[name] = parseInt(value);
      }
    });

    if (name === 'group-name') {
      groupForm.evChargerGroupName = value;
    }

    calculateCapacity();
  };

  const saveUpdatedGroup = () => {
    setProcessing(true);

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        selectedGXId +
        '/gridInterconnect/evChargerGroup',
      true,
      'POST',
      JSON.stringify(groupForm),
      updateDeviceData,
      setProcessing,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
  };

  return (
    <div className="edit-ev-group">
      <Modal
        modalTitle={isNewGroup ? 'Create New Group' : 'Group Edit'}
        modalImage={modalImage}
        clearModal={clearModal}
        showMobile={showMobile}
        updateSettings={saveUpdatedGroup}
        renderModalContent={
          <>
            {selectedGroup && (
              <>
                <div className="group-edit">
                  <input
                    className="name-container"
                    name="group-name"
                    placeholder={selectedGroup.evChargerGroupName}
                    onChange={(e) => handleInputUpdate(e)}
                  ></input>

                  <div className="settings-container">
                    <div className="limits-container">
                      <div className="limits">
                        <h5>Set Limits</h5>
                        {Object.entries(selectedGroup.powerDecisionLimits).map(([key, value]) => {
                          if (!hasBattery && key === 'Microgrid') {
                            return null;
                          }

                          return (
                            <React.Fragment key={`${key}-limits`}>
                              <div className="limit">
                                <label htmlFor="performance">{key}</label>

                                <div>
                                  <input
                                    name={key}
                                    type="number"
                                    placeholder={value}
                                    defaultValue={value}
                                    onChange={(e) => handleInputUpdate(e)}
                                    min="1"
                                    max="100"
                                  ></input>
                                  <span>%</span>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>

                    <div className="capacity-container">
                      <h5>Capacity</h5>
                      {capacityArray.map((item, index) => (
                        <div className="capacity" key={`${index}-capacity`}>
                          {item} kW
                        </div>
                      ))}
                    </div>

                    <hr />

                    <div className="devices-container">
                      <h5>Select Device(s)</h5>

                      <div className="devices">
                        <Checkbox
                          id="all"
                          name="all"
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={selectedKeys.length === groupList.length}
                        />
                        Select All
                      </div>

                      {groupList}
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        }
      />
    </div>
  );
};

export default EditEvGroup;
